import { Link } from 'react-router-dom';
import './Home.css';

const companies = [
  { tag: 'Media · Culture · UGC', name: 'D36 TV', accent: '#ffdd44', desc: 'Linear UGC music television for the South Asian diaspora. Lean-back, curated channels.', live: 'https://wall.d36.world/', statusText: 'Live — watch it ↗' },
  { tag: 'Civic · Data · LA', name: 'LA Receipts', accent: '#E63946', desc: 'Follow every dollar in Los Angeles — budgets, payroll, vendors, and services, built on public city data.', live: 'https://www.lareceipts.com/', statusText: 'Live — explore it ↗' },
  { tag: 'Live · Touring · AI', name: 'Paul', accent: '#C8E650', desc: 'AI-native platform reimagining tour management for artists, managers, and production teams.', live: 'https://paul-mu-vert.vercel.app/', statusText: 'Building — see the vision ↗', dot: 'b' },
  { tag: 'Music · Finance · AI', name: 'Cadence', accent: '#10b981', desc: 'Institutional-grade music catalog valuation. Underwrite catalogs in minutes, not weeks.', live: 'https://cadence-bice.vercel.app/', statusText: 'Building — see the vision ↗', dot: 'b' },
  { tag: 'Music · Distribution · AI', name: 'Heart', accent: '#B2B89C', desc: 'AI-native music distribution. A persistent agent for the entire operational backend.', live: 'https://heart-pitch.vercel.app/', statusText: 'Building — see the vision ↗', dot: 'b' },
  { tag: 'Music · Media · Superfandom', name: 'Parda', accent: '#1a1aff', desc: 'Network architecture for superfandom. Artist-owned television networks with direct-to-fan commerce built in.', live: 'https://parda.tv/', statusText: 'Live — see it ↗' },
  { tag: 'Education · AI', name: 'Book Club', accent: '#C8A92A', desc: 'Nonfiction books transformed into interactive AI learning applications.' },
  { tag: 'Music · Business · AI', name: 'Gordy', accent: '#A855F7', desc: 'The teammate who never misses an email. An AI agent that runs the business side of music for managers and artists.', live: 'https://www.trygordy.com/', statusText: 'Live — try it ↗' },
];

export default function Home() {
  return (
    <>
      <section className="hero">
        <h1 className="hero-headline">
          Los Angeles–<br/>based<span className="inline-tag">product studio</span><br/>building companies
        </h1>
        <div className="hero-sub">Ideate<br/>+ Build<br/>+ Ship<br/><span className="hero-byline">by Abhi Kanakadandila · D36</span></div>
      </section>

      <div className="marquee-strip">
        <div className="marquee-inner">
          <span>Entertainment</span><span className="dot">·</span>
          <span>Education</span><span className="dot">·</span>
          <span>Music</span><span className="dot">·</span>
          <span>Touring</span><span className="dot">·</span>
          <span>Legal</span><span className="dot">·</span>
          <span>Culture</span><span className="dot">·</span>
          <span>Finance</span><span className="dot">·</span>
          <span>Civic Data</span><span className="dot">·</span>
          <span>Live</span><span className="dot">·</span>
          <span>AI</span><span className="dot">·</span>
          <span>Entertainment</span><span className="dot">·</span>
          <span>Education</span><span className="dot">·</span>
          <span>Music</span><span className="dot">·</span>
          <span>Touring</span><span className="dot">·</span>
          <span>Legal</span><span className="dot">·</span>
          <span>Culture</span><span className="dot">·</span>
          <span>Finance</span><span className="dot">·</span>
          <span>Civic Data</span><span className="dot">·</span>
          <span>Live</span><span className="dot">·</span>
          <span>AI</span><span className="dot">·</span>
        </div>
      </div>

      <div className="bottom-bar">
        <div className="bottom-left">
          We ideate, design, and ship AI-native products for the industries we operate in every day. Not an idea factory — a product factory.
        </div>
        <Link to="/portfolio" className="credentials-card">
          <div className="thumb">8</div>
          <div>
            <div className="cred-label">View Portfolio</div>
            <div className="cred-desc">Explore current ventures across entertainment, music, media, and education.</div>
          </div>
        </Link>
      </div>

      <section className="founder-strip">
        <div className="section-label">Founder</div>
        <div className="founder-strip-inner">
          <div className="founder-strip-avatar">AK</div>
          <div>
            <div className="founder-strip-name">Abhi Kanakadandila</div>
            <p className="founder-strip-bio">
              Founder and CEO of <a className="inline-link" href="https://www.d36.world" target="_blank" rel="noreferrer">D36</a>,
              the Los Angeles label and media company for South Asian music. Previously VP of Strategy at music distribution
              company Stem, Finance at SpaceX on the early Starlink plan, and investment banking at Bank of America Merrill
              Lynch. NYU Stern. St. Louis native. Lakeshore is where the problems he hits operating in music become
              AI-native products — designed, built, and shipped in-house.
            </p>
            <Link to="/team" className="inline-link">Full bio →</Link>
          </div>
        </div>
      </section>

      <section className="studio-section">
        <div className="studio-label">What is a Product Studio?</div>
        <div className="studio-content">
          <div className="studio-lead">
            A product studio builds companies from the ground up. We don't fund other people's ideas — we create the idea, build the product, establish the brand, and define how it reaches the market. Ideas are the input. Shipped products are the output.
          </div>
          <div className="studio-grid">
            <div className="studio-block">
              <div className="studio-block-label">How it starts</div>
              <p>Most of our companies start the same way — a conversation. A domain expert in music, media, law, or education says something offhand about how broken a part of their world is. We listen. We ask questions. And if we see a real problem worth solving, we build.</p>
            </div>
            <div className="studio-block">
              <div className="studio-block-label">How it works</div>
              <p>Every company that comes out of Lakeshore starts here. We own it from day one — designed, built, and shipped in-house. When outside investors come in, they're investing into something that already has a product, a thesis, and a plan.</p>
            </div>
            <div className="studio-block">
              <div className="studio-block-label">The result</div>
              <p>A portfolio of companies that share a common philosophy — built differently, by design, from the start.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio" id="portfolio">
        <div className="section-label">Current Ventures</div>
        <div className="portfolio-grid">
          {companies.map(c => {
            const inner = (
              <>
                <div className="p-accent" style={{ background: c.accent }} />
                <div className="p-tag">{c.tag}</div>
                <div className="p-name">{c.name}</div>
                <div className="p-desc">{c.desc}</div>
                {c.live
                  ? <div className="p-status"><span className={`sdot ${c.dot || ''}`}></span> {c.statusText}</div>
                  : <div className="p-status"><span className="sdot b"></span> Building</div>}
              </>
            );
            return c.live ? (
              <a href={c.live} target="_blank" rel="noreferrer" className="portfolio-item" key={c.name}>{inner}</a>
            ) : (
              <Link to="/portfolio" className="portfolio-item" key={c.name}>{inner}</Link>
            );
          })}
        </div>
      </section>
    </>
  );
}
